import { CommonModule } from '@angular/common';
import { HttpClient, HttpResponse, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { RouterOutletComponent } from './components/router-outlet/router-outlet.component';
import { RouterLink, RouterLinkWithHref } from './directives/router-link.directive';
import { SchemaDirective } from './directives/schema.directive';
import { MetaModule } from './meta/meta.module';
import { PAGE_CHANGE } from './meta/tokens';
import { ContentCache } from './services/content-cache.service';
import { ContentResolver } from './services/content.resolver';
import { GET_CONTENT_FN, loadContent } from './tokens';
import { LazyLoadModule } from '../lazy-load/lazy-load.module';
import { BASE_URL } from '../misselaineous/boot.tokens';


@Injectable({
    providedIn: 'root'
})
class ContentWithSearchResolver {
    constructor(
        private contentResolver: ContentResolver,
        // private searchResolver: SearchResolver<unknown>,
    ) {}
    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<unknown> {
        let response = {};
        Object.assign(response, await this.contentResolver.resolve(route, state))
        let fakeRoute = Object.assign({}, route);
        fakeRoute.data = response;
        // response['products'] = await this.searchResolver.resolve(fakeRoute, state)
        return response;
    }
}


@NgModule({ declarations: [
        RouterLink,
        RouterLinkWithHref,
        RouterOutletComponent,
        SchemaDirective,
    ],
    exports: [
        RouterLink,
        RouterLinkWithHref,
        // RouterModule,
        RouterOutletComponent,

        LazyLoadModule,
    ], imports: [CommonModule,
        LazyLoadModule], providers: [
        ContentCache,
        {
            provide: GET_CONTENT_FN,
            deps: [ContentCache, BASE_URL, HttpClient],
            useFactory: (cache: ContentCache, baseUrl: string, httpClient: HttpClient) => (url: string) => cache
                .getOnceOrLoad('page', loadContent(url, baseUrl, httpClient)
                .pipe(take(1), map((response: HttpResponse<any>) => response.body)))
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class NavigationModule {



}

